var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-overlay",
        {
          attrs: {
            show: _vm.blockingLoader,
            "spinner-small": "true",
            variant: "primary",
            opacity: "0.8",
          },
        },
        [
          _vm.loadingSpinner
            ? _c(
                "div",
                { staticClass: "d-flex justify-content-center" },
                [
                  _c("b-spinner", {
                    staticStyle: { width: "3rem", height: "3rem" },
                    attrs: { variant: "success", label: "Spinning" },
                  }),
                ],
                1
              )
            : _vm._e(),
          !_vm.loadingSpinner
            ? _c(
                "div",
                [
                  _c(
                    "form-wizard",
                    {
                      staticClass: "mb-3",
                      attrs: {
                        color: "#B1D06C",
                        title: null,
                        subtitle: null,
                        shape: "square",
                        "finish-button-text": "Submit",
                        "back-button-text": "Previous",
                      },
                      on: { "on-complete": _vm.formSubmitted },
                    },
                    [
                      _c(
                        "tab-content",
                        { attrs: { title: "Lead Details" } },
                        [
                          _c(
                            "b-tabs",
                            {
                              attrs: { pills: "" },
                              on: {
                                input: function ($event) {
                                  return _vm.getValue($event)
                                },
                              },
                            },
                            [
                              _c(
                                "b-tab",
                                { attrs: { title: "Individual", active: "" } },
                                [
                                  _c(
                                    "b-card-text",
                                    [
                                      _c(
                                        "b-card",
                                        { attrs: { title: "Add Individual" } },
                                        [
                                          _c("AddLead", {
                                            ref: "addLeadProfile",
                                            attrs: {
                                              individual: _vm.individual,
                                            },
                                            on: {
                                              "update:individual":
                                                _vm.updateIndividual,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "b-tab",
                                { attrs: { title: "Company" } },
                                [
                                  _c(
                                    "b-card-text",
                                    [
                                      _c(
                                        "b-card",
                                        { attrs: { title: "Add Company" } },
                                        [
                                          _c("AddCompany", {
                                            ref: "addCompanyProfile",
                                            attrs: { company: _vm.company },
                                            on: {
                                              "update:company":
                                                _vm.updateCompany,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }